import React from "react";

import { InputLabelProps } from "@models/components/formElements.model";

const InputLabel: React.FC<InputLabelProps> = ({
  className = "",
  isError,
  isIcon = false,
  labelText,
  onChange,
  onKeyDown,
  spellCheck = true,
  testId,
  value,
}) => (
  <>
    <input
      data-testid={testId}
      className={`form-control${
        isError ? " border border-danger" : ""
      } ${className}`}
      value={value}
      onChange={onChange}
      onKeyDown={onKeyDown}
      spellCheck={spellCheck}
      name={testId}
    />
    <label className={isError ? "text-danger" : ""}>{labelText}</label>
    {isIcon && <i className="fa-solid fa-envelope" />}
  </>
);

export default InputLabel;
